export const sliderItems = [
  {
    id: 1,
    img: '/shopping1.png',
    title: 'SUMMER SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#f5fafd',
  },
  {
    id: 2,
    img: '/shopping2.png',
    title: 'AUTUMN COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#fcf1ed',
  },
  {
    id: 3,
    img: '/shopping3.png',
    title: 'LOUNGEWEAR LOVE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: '#fbf0f4',
  },
];

export const categories = [
  {
    id: 1,
    img: '/lounge.jpg',
    title: 'LOUNGEWARE LOVE',
  },
  {
    id: 2,
    img: '/shirt.jpg',
    title: 'SHIRT STYLE!',
  },
  {
    id: 3,
    img: '/jacket.webp',
    title: 'LIGHT JACKETS',
  },
];

export const popularProducts = [
  {
    id: 1,
    img: '/bag.png',
  },
  {
    id: 2,
    img: '/jack.png',
  },
  {
    id: 3,
    img: '/kimono.png',
  },
  {
    id: 4,
    img: '/sunglass.png',
  },
  {
    id: 5,
    img: '/sweater.png',
  },
  {
    id: 6,
    img: '/trouser.png',
  },
  {
    id: 7,
    img: '/tshirt.png',
  },
  {
    id: 8,
    img: '/watch.png',
  },
];
